import { render, staticRenderFns } from "./IcelandicCharacters.vue?vue&type=template&id=00d1b49e&scoped=true&"
import script from "./IcelandicCharacters.vue?vue&type=script&lang=js&"
export * from "./IcelandicCharacters.vue?vue&type=script&lang=js&"
import style0 from "./IcelandicCharacters.vue?vue&type=style&index=0&id=00d1b49e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00d1b49e",
  null
  
)

export default component.exports